// src/axiosConfig.js
import axios from "axios";


// Usar variable de entorno
//const API_URL = process.env.REACT_APP_API_URL;
//console.log("API_URL:", API_URL);

// Crear instancia de Axios
const api = axios.create({


  //baseURL: API_URL, // tu backend FastAPI
  //baseURL: "http://localhost:8000", // tu backend FastAPI
  baseURL: "/api", // tu backend FastAPI

  withCredentials: true, // NUEVO Muy importante si usas sesión por cookies
});

// Agregar token a cada request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  console.log("Enviando token:", token); // temporal, para debug
  if (token) {
    
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Manejar respuestas con error (ej. token expirado → 401)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Borrar sesión y redirigir al login
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      // Redirige manualmente
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
